import { formatNumber } from '@/utils/format'
import type { ChartPoint } from '../api'

/** Horizontal magnitude bars (single hue) with direct value labels. */
export function RankedBars({ data }: { data: ChartPoint[] }) {
  const max = Math.max(1, ...data.map((d) => d.value))
  return (
    <ul className="space-y-3">
      {data.map((d) => (
        <li key={d.label}>
          <div className="flex items-baseline justify-between gap-3 text-sm">
            <span className="truncate text-ink-soft">{d.label}</span>
            <span className="font-semibold text-ink tabular">{formatNumber(d.value)}</span>
          </div>
          <div className="mt-1.5 h-2 rounded-full bg-surface-sunken" aria-hidden="true">
            <div
              className="h-full rounded-full bg-brand-500"
              style={{ width: `${(d.value / max) * 100}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  )
}
